/** Determining when offer caps are not editable (complex or API-managed offers without manual override) */

export function isOfferAutomatic(offer) {
  return Boolean(offer && offer.external_offer_id);
}

export function isOfferComplex(offer) {
  return Boolean(offer && offer.type === 'complex');
}

// Click / impression caps: locked for complex offers, or automatic offers unless Lock caps is on.
export function shouldLockOfferClickImpressionCaps(offer) {
  if (isOfferComplex(offer)) {
    return true;
  }
  if (isOfferAutomatic(offer) === false) {
    return false;
  }
  return Boolean(offer.lock_caps) === false;
}

// Conversion-related caps: locked for complex offers, or automatic offers unless Lock conversion caps is on.
export function shouldLockOfferConversionCaps(offer) {
  if (isOfferComplex(offer)) {
    return true;
  }
  if (isOfferAutomatic(offer) === false) {
    return false;
  }
  return Boolean(offer.lock_conversion_caps) === false;
}